import { render } from "./PlotModal.vue?vue&type=template&id=3974005e"
import script from "./PlotModal.vue?vue&type=script&lang=js"
export * from "./PlotModal.vue?vue&type=script&lang=js"

import "./PlotModal.vue?vue&type=style&index=0&id=3974005e&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__